import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  isFinal?: boolean;
  className?: string;
  href?: string;
}
export function CTAButton({
  text,
  isFinal = false,
  className = '',
  href: customHref
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isFinal) {
      e.preventDefault();
      document.getElementById('compra')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const href = customHref || (isFinal ? '#compra' : '#compra');
  return <motion.a href={href} onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`group relative inline-flex items-center justify-center gap-3 px-8 py-4 text-lg md:text-xl font-bold text-white bg-emerald-600 rounded-xl overflow-hidden shadow-[0_0_20px_rgba(5,150,105,0.4)] hover:shadow-[0_0_30px_rgba(5,150,105,0.6)] transition-shadow duration-300 ${className}`} data-id="element-78">
      <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg opacity-30 bg-gradient-to-b from-transparent via-transparent to-black" data-id="element-79"></span>
      <span className="relative flex items-center gap-2" data-id="element-80">
        {text}
        <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-81" />
      </span>
    </motion.a>;
}